export { default as Colors } from "./colors";



// WEBPACK FOOTER //
// ./src/core/admin/components/styled/index.js